import { t } from "@lingui/macro";
import React, { useContext } from "react";
import { ScrollView } from "react-native";

import { Box, Pressable, Text } from "../../../primitive";
import { MenuContentProps, MenuContext, MenuContextType } from "../types";

/**
 *
 * This component provides a standardized field to place your
 * internal content. It controls padding and sizing
 */
export const MenuContent = ({
  children,
  size = "regular",
  maxHeight = 360,
  testID,
  showVerticalScrollIndicator = false,
}: MenuContentProps) => {
  const setWidth = sizeToWidthMap[size];
  const context = useContext<MenuContextType>(MenuContext);
  const { triggerWidth, isActionSheet, showActionSheetDoneButton, onClose } =
    context;
  const curWidth = isActionSheet
    ? "100%"
    : size === "matchTrigger"
    ? triggerWidth
    : setWidth;

  const shouldShowActionSheetDoneButton =
    showActionSheetDoneButton && isActionSheet;

  return (
    <Box
      width={curWidth}
      maxHeight={isActionSheet ? "100%" : maxHeight}
      paddingVertical={
        isActionSheet && !showActionSheetDoneButton ? 4 : isActionSheet ? 0 : 2
      }
      backgroundColor={"surface-primary"}
      shadowOffset={{ width: 0, height: 4 }}
      shadowRadius={isActionSheet ? 0 : 16}
      shadowColor={"black"}
      shadowOpacity={isActionSheet ? 0 : 0.08}
      borderWidth={isActionSheet ? 0 : 1.5}
      borderColor="outline-default"
      borderRadius={isActionSheet ? "4" : "2"}
      flexDirection={"column"}
      flex={1}
      testID={testID}
    >
      {shouldShowActionSheetDoneButton ? (
        <Pressable
          testID="action-sheet-done-button"
          marginBottom={2}
          onPress={() => {
            onClose?.();
          }}
          borderColor="outline-default"
          borderBottomWidth={1}
          paddingHorizontal={4}
          height={56}
          flexDirection="column"
          justifyContent={"center"}
        >
          <Text variant={"mainBaseSemiBold"} color="text-main-primary">
            {t`Done`}
          </Text>
        </Pressable>
      ) : null}
      <Box flexShrink={1} paddingHorizontal={isActionSheet ? 3 : 2}>
        <ScrollView
          showsVerticalScrollIndicator={showVerticalScrollIndicator}
          scrollEventThrottle={16}
        >
          {children}
        </ScrollView>
      </Box>
    </Box>
  );
};

const sizeToWidthMap = {
  small: 160,
  regular: 256,
  large: 400,
  extraLarge: 480,
  jumbotron: 880,
  matchTrigger: 1000,
};
